import React from "react";
import styles from "./stylesComponent/CardCompras.module.css";
import { useState, useEffect  } from "react";
import {Link} from 'react-router-dom';
import {Dialog, AppBar, Toolbar, IconButton, Slide, TextField, Rating, DialogTitle, DialogContent, DialogActions, Button, Typography, Icon} from '@mui/material';
import CardResennas from "./CardResennas";
import { ComponerMensajeDialog } from '../Mensajes';
import Swal from 'sweetalert2';

/*Transición de formulario de reseña */
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const TablaProductos = ({ productos, resennas, ProductosDevueltos, verResenna, escribirResenna, editarResenna, solicitarEliminacionResenna, setCompose }) => {
    return(
        <table className={styles.tablaProductos}>
            <thead>
                <tr>
                    <th colSpan={2}>Producto</th>
                    <th>Detalles del producto</th>
                    <th>Precio</th>
                    <th>Reseñas</th>
                    <th>Devolución</th>
                </tr>
            </thead>
            <tbody>
                {productos.map((producto, index) => {

                    if(!producto || (producto.Nombre === null && producto.Tematica === null, producto.Descripcion === null && producto.ImagenPortada === null && producto.FechaSubida === null)){
                        return (
                            <tr key={`eliminado-${index}`}>
                                <td colSpan={2} style={{ textAlign: "center", fontStyle: "italic", color: 'black'}}>
                                    <span>Este producto fue eliminado.</span>
                                </td>
                                <td style={{ paddingLeft: '105px', paddingRight: '105px', textAlign: "center", color: "#888"}}>—</td>
                                <td className={styles.celdaPrecio} style={{ textAlign: "center", color: "#000" }}>
                                    {producto?.Precio != null ? producto.Precio.toFixed(2) + " €" : "—"}
                                </td>
                                <td style={{ textAlign: "center", color: "#888" }}>—</td>
                                <td style={{ textAlign: "center", color: "#888" }}>—</td>
                            </tr>
                        );
                    }

                    //Tutor eliminado
                    const tutorEliminado = !producto.tutor;

                    //Producto devuelto
                    const idDevueltosStr = (ProductosDevueltos || []).map((id) =>
                        id.toString()
                    );

                    const estaDevuelto = idDevueltosStr.includes(producto._id.toString());
                    
                    //buscar reseña correspondiente al producto
                    const res = resennas.find(r => r.Id_Contenido.toString() === producto._id.toString());
                    
                    return(
                        <tr key={index}>
                            <td className={styles.celdaImagen}><img src={`data:image/png;base64,${producto.ImagenPortada}`} alt={`${producto.Nombre}`} /></td> 
                            <td className={styles.celdaNombre}>
                                {producto.Nombre}
                            </td>
                            <td>
                                <Link to={{pathname: `/detalleContenido/${producto._id}`, state: { producto: producto, tutor: producto.tutor }}}>
                                    <button className={styles.botonTabla}>Ver detalles</button>
                                </Link>
                            </td>
                            <td className={styles.celdaPrecio}>
                                {(producto.Precio).toFixed(2)} €
                            </td>
                            <td>
                                {res ? (
                                    <div className={styles.contenedorResenas}>
                                        <button className={styles.botonTabla} onClick={() => verResenna(producto, res)}>Ver reseña</button>
                                        <button className={styles.botonTabla} onClick={() => editarResenna(producto, res)}>Editar reseña</button>
                                        <button className={styles.botonTabla} onClick={() => solicitarEliminacionResenna(producto, res)}>Eliminar reseña</button>
                                    </div>
                                    ) : (<button className={styles.botonTabla} onClick={() => escribirResenna(producto)}>Escribir reseña</button>)
                                }
                            </td>
                            <td>
                                {estaDevuelto ? (<span style={{ textAlign: "center", fontStyle: "italic", color: 'black'}}> Este producto ha sido devuelto</span>) :
                                (<button className={styles.botonTabla} onClick={() => {
                                                    const asuntoDevolucion = `Solicitud para gestionar la devolución del producto ${producto.Nombre}`;
                                                    setCompose({
                                                        abierto: true,
                                                            inicial: {
                                                                Destinatarios: producto.tutor.Usuario,
                                                                Asunto: asuntoDevolucion,
                                                                Contenido: "",
                                                                Archivo: null,
                                                                respuestaA: false,
                                                                leerSoloDestinatarios: true,
                                                                leerSoloAsunto: true,
                                                            },
                                                        });
                                                    }}
                                                    disabled={tutorEliminado}
                                                >
                                                    {tutorEliminado
                                                        ? "Tutor eliminado"
                                                        : "Gestionar devolución"
                                                    }
                                                </button>
                                )
                                }
                            </td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
    );
};

const CardCompras = ({ compra,  mutateCompras }) => {
    const [usuario] = useState(() => {
        const usuarioAlmacenado = localStorage.getItem("userLogueado");
        return usuarioAlmacenado ? JSON.parse(usuarioAlmacenado) : null;
    });
    const [resennas, setResennas] = useState([]);
    const [seleccion, setSeleccion] = useState({producto: null, resenna: null}); //Seleccionar producto y/o reseña del usuario tras pulsar botón
    const [formulario, setFormulario] = useState(false); //Comprobar si usuario ha pulsado en insertar o editar para abrir formulario
    const [editando, setEditando] = useState(false); //Usuario pulsa en editar
    const [abierto, setAbierto] = useState(false);  //Abrir modal
    //Crear nueva reseña
    const [nuevaResenna, setNuevaResenna] = useState({
        Valoracion: 0,
        Titulo: "",
        Descripcion: "",
    });
    const [confirmarEliminacion, setconfirmarEliminacion] = useState(false); //Abrir modal de eliminacion
    
    //Estado para poder enviar mensajes a tutor
    const [compose, setCompose] = useState({ abierto: false, inicial: {} });

    let baseUrl;
    if(process.env.NODE_ENV === 'development') baseUrl = 'http://localhost:8080';
    else baseUrl='https://app-formacion.vercel.app';
    
    //Consultar reseñas de los productos
    useEffect(() => {
        const resennasUsuario = async () => {
            try{
                const vectorContenido = compra.Id_Contenido;
               
                const peticiones = vectorContenido.map(async (idCont) => {
                    const respuesta = await fetch(`${baseUrl}/api/resennas/search/users/${usuario._id}/${idCont}`, {
                        method: "GET",
                        headers: { "Content-Type": "application/json" },
                    });

                    if(respuesta.ok){
                        const resennaCompra = await respuesta.json();
                        return resennaCompra;
                    }
                    else return null;
                });

                const resultados = await Promise.all(peticiones);
                const resennasFiltradas = resultados.filter(res => res !== null);

                setResennas(resennasFiltradas);
                

            }catch(error){
                console.error("Error al obtener las resennas de los productos de la compra: "+ error.message);
            }
        };

        if(compra.Id_Contenido?.length > 0) resennasUsuario();
    },[usuario._id, compra.Id_Contenido]);

    //Ver reseña
    const manejarVistaResenna = (producto, resenna) => {
        setSeleccion({producto, resenna});
        setAbierto(true);
        setFormulario(false);
    }

    //Nueva reseña
    const manejarEscrituraResenna = (producto) => {
        setSeleccion({ producto, resenna: null });
        setNuevaResenna({ Titulo: "", Descripcion: "", Valoracion: 0 });
        setFormulario(true);
        setEditando(false);
        setAbierto(true);
    };

    //Edicion de reseña
    const manejarEdicionResenna = (producto, resenna) => {
        setSeleccion({ producto, resenna });
        setNuevaResenna({
            Titulo: resenna.Titulo,
            Descripcion: resenna.Descripcion,
            Valoracion: resenna.Valoracion,
        });
        setFormulario(true);
        setEditando(true);
        setAbierto(true);
    };

    //Eliminacion de reseña
    const SolicitarEliminacionResenna = (producto, resenna) => {
        setAbierto(false);
        setSeleccion({producto, resenna });
        setconfirmarEliminacion(true);
    }

    //Añadida reseña o editada
    const manejarCambio = (campo, valor) => {
        setNuevaResenna(prev => ({ ...prev, [campo]: valor }));
    };

    //Enviar reseñas (nueva o editada)
    const manejarEnvio = async () => {
        if (nuevaResenna.Valoracion === 0) {
            await Swal.fire({
                icon: 'warning',
                title: 'Atención',
                text: 'Por favor, introduzca una valoración',
                confirmButtonText: 'OK'
            });
            return;
        }

        if(!nuevaResenna.Titulo.trim()){
            await Swal.fire({
                icon: 'warning',
                title: 'Atención',
                text: 'El título no puede estar vacío',
                confirmButtonText: 'OK'
            });
            return;
        }
        if(!nuevaResenna.Descripcion.trim()){
            await Swal.fire({
                icon: 'warning',
                title: 'Atención',
                text: 'La descripción no puede estar vacía',
                confirmButtonText: 'OK'
            });
            return;
        }

        //URL y metodo diferente para Editar o Insertar
        let url = `${baseUrl}/api/resennas`;
        let method = "POST";

        if(editando){
            url = `${baseUrl}/api/resennas/${seleccion.resenna._id}`;
            method = "PUT";
        }

        const cuerpo = {
          Id_Usuario: usuario._id,
          Id_Contenido: seleccion.producto._id,
          Fecha: new Date(),
          Titulo: nuevaResenna.Titulo,
          Descripcion: nuevaResenna.Descripcion,
          Valoracion: nuevaResenna.Valoracion
        };

        try {
          const respuesta = await fetch(url, {
            method: method,
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(cuerpo)
          });
    
          if (respuesta.ok) {
            const respGuardada = await respuesta.json();

            if(editando){
                setResennas(prev => prev.map(r => r._id.toString() === respGuardada._id.toString() ? respGuardada : r));
                setSeleccion(sel => ({ ...sel, resenna: { ...respGuardada} }));
            }
            else{
                setResennas(prev => [...prev, respGuardada]);
            }

            mutateCompras();
            setAbierto(false);
            setEditando(false);      
            setFormulario(false);
          } else {
            console.error("Error al enviar la reseña");
          }
        } catch (error) {
            console.error("Error al enviar la reseña:", error.message);
            await Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'No se pudo guardar la reseña',
                confirmButtonText: 'Ok'
            });
        }
    };

    //Eliminar reseña
    const manejarEliminacionResenna = async () => {
        try {
            const respuesta = await fetch(`${baseUrl}/api/resennas/${seleccion.resenna._id}`,
                { method: "DELETE" }
            );
            if(!respuesta.ok) throw new Error();
            setResennas((prev) =>
                prev.filter((r) => r._id !== seleccion.resenna._id)
            );
            mutateCompras();
            await Swal.fire({
                icon: 'success',
                title: 'Éxito',
                text: 'Reseña eliminada correctamente',
                confirmButtonText: 'OK'
            });
        } catch {
            await Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Error al eliminar la reseña',
                confirmButtonText: 'OK'
            });
        } finally {
            setconfirmarEliminacion(false);
        }
    }

    //Cierre de los modales
    const manejarCierre = () => {
        setAbierto(false);
        setSeleccion({producto: null, resenna: null})
    }

    return(
        <div className={styles.card}>
            <div className={styles.contenedorCabecera}>
                <h3>Compra con Código {compra.Codigo}</h3>
                <Link to={{pathname: `/compra/exitosa/${compra._id}`}}>
                    <button className={styles.botonCabecera}>Acceder a los productos</button>
                </Link>

                <Link to={{ pathname: `/detallesCompra/${compra._id}`, state: { compra: compra } }}>
                    <button className={styles.botonCabecera}>Ver detalles</button>
                </Link>
            </div>

            <div className={styles.contenedorTabla}>
                {compra.productos && compra.productos.length > 0 && (
                    <TablaProductos productos={compra.productos} resennas={resennas} ProductosDevueltos={compra.ProductosDevueltos || []} verResenna={manejarVistaResenna} escribirResenna={manejarEscrituraResenna} editarResenna={manejarEdicionResenna} solicitarEliminacionResenna={SolicitarEliminacionResenna}  setCompose={setCompose}/>
                )}
            </div>

            
            {/*Modal para ver reseña */}
            {!formulario && (
                <Dialog open={abierto} onClose={manejarCierre} fullWidth maxWidth="md">
                    <DialogTitle>
                        {`Reseña de ${seleccion.producto?.Nombre || ""}`}
                    </DialogTitle>
                    <DialogContent dividers>
                        {seleccion.resenna && (
                            <div className={styles.modalVerResennas}>
                                <CardResennas resena={seleccion.resenna} style={{width: '100px'}} />
                            </div>
                        )}
                    </DialogContent>
                    <DialogActions>
                        <Button 
                            sx={{ 
                               textTransform: 'none',
                                '& .MuiButton-label': {
                                    textTransform: 'lowercase',         
                                    '&::first-letter': {
                                        textTransform: 'uppercase'        
                                    }
                                }
                            }} onClick={manejarCierre}>
                            Cerrar
                        </Button>
                    </DialogActions>
                </Dialog>
            )}

            {/*Modal para eliminar reseña */}
            <Dialog
                open={confirmarEliminacion}
                onClose={() => setconfirmarEliminacion(false)}
                fullWidth
                maxWidth="md"
            >
                <DialogTitle>
                    {`Eliminar reseña de ${seleccion.producto?.Nombre}`}
                </DialogTitle>
                <DialogContent>
                    <Typography>
                        ¿Estás seguro de que deseas eliminar esta reseña? Después no podrá deshacer el cambio
                    </Typography>
                </DialogContent>
                    <DialogActions>
                        <Button 
                            sx={{ 
                                textTransform: 'none',
                                '& .MuiButton-label': {
                                    textTransform: 'lowercase',         
                                    '&::first-letter': {
                                        textTransform: 'uppercase'        
                                    }
                                }
                            }} 
                            onClick={() => setconfirmarEliminacion(false)}
                        >
                            No
                        </Button>
                        <Button 
                            sx={{ 
                                textTransform: 'none',
                                '& .MuiButton-label': {
                                    textTransform: 'lowercase',         
                                    '&::first-letter': {
                                        textTransform: 'uppercase'        
                                    }
                                }
                            }} 
                            color="error" 
                            onClick={manejarEliminacionResenna}
                        >
                            Sí, eliminar
                        </Button>
                    </DialogActions>
            </Dialog>

            {/*Modal para escribir reseña*/}
            {formulario && (
                <Dialog fullScreen open={abierto} onClose={manejarCierre} TransitionComponent={Transition}>
                    <AppBar sx={{ position: "relative "}}>
                        <Toolbar>
                            <IconButton edge="start" color="inherit" onClick={manejarCierre} aria-label="close">
                                <Icon>X</Icon>
                            </IconButton>
                            <Typography sx={{ml: 2, flex: 1}} variant="h6">
                                {editando ? `Editar reseña para ${seleccion.producto?.Nombre}` : `Escribir reseña para ${seleccion.producto?.Nombre || ""}`}
                            </Typography>
                        </Toolbar>
                    </AppBar>
                    <DialogContent>
                        <div style={{ maxWidth: "700px", margin: "0 auto" }}>
                        <TextField
                            fullWidth
                            label="Título"
                            value={nuevaResenna.Titulo}
                            onChange={e => manejarCambio("Titulo", e.target.value)}
                            margin="normal"
                        />
                        <TextField
                            fullWidth
                            label="Descripción"
                            multiline
                            rows={4}
                            value={nuevaResenna.Descripcion}
                            onChange={e => manejarCambio("Descripcion", e.target.value)}
                            margin="normal"
                        />
                        <Rating
                            name="Valoracion"
                            value={nuevaResenna.Valoracion}
                            precision={0.5}
                            onChange={(_,v) => manejarCambio("Valoracion", v)}
                        />
                        <Button variant="contained"
                            sx={{
                                mt: 2,               
                                display: "block",    
                                mx: "auto",          
                                backgroundColor: "#007bff",
                                color: "#fff",
                                textTransform: "lowercase",
                                "::first-letter": {
                                    textTransform: "uppercase"
                                },
                                "&:hover": {
                                    backgroundColor: "#007bff",
                                },
                                "&.Mui-disabled": {
                                    backgroundColor: "#007bff33", 
                                    color: "#fff",   
                                },    
                            }} 
                            autoFocus 
                            onClick={manejarEnvio} 
                            disabled={nuevaResenna.Valoracion === 0 || !nuevaResenna.Titulo.trim() || !nuevaResenna.Descripcion.trim()}>
                                {editando ? "Guardar cambios" : "Subir reseña"}
                        </Button>
                        </div>
                    </DialogContent>
                </Dialog>
            )}

            <ComponerMensajeDialog
                abierto={compose.abierto}
                inicial={compose.inicial}
                onClose={() => setCompose({ abierto: false, inicial: {} })}
            />
        </div>
    );
};

export default CardCompras;